import { render, staticRenderFns } from "./nextTopic.vue?vue&type=template&id=2d676bb0&scoped=true"
import script from "./nextTopic.vue?vue&type=script&lang=js"
export * from "./nextTopic.vue?vue&type=script&lang=js"
import style0 from "./nextTopic.vue?vue&type=style&index=0&id=2d676bb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d676bb0",
  null
  
)

export default component.exports